// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffportal/v1/simulation_service.proto (package bffportal.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_acl_v1_acl } from "../../acl/v1/acl_pb";
import type { FloatingIndexItem } from "./floating_index_model_pb";
import { file_bffportal_v1_floating_index_model } from "./floating_index_model_pb";
import type { OrderSimulationRelationWithNumber, OrderWithNumber, SimulatePFEOutputsWithRelationNumber } from "../../devtool/v1/service_pb";
import { file_devtool_v1_service } from "../../devtool/v1/service_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffportal/v1/simulation_service.proto.
 */
export const file_bffportal_v1_simulation_service: GenFile = /*@__PURE__*/
  fileDesc("CiViZmZwb3J0YWwvdjEvc2ltdWxhdGlvbl9zZXJ2aWNlLnByb3RvEgxiZmZwb3J0YWwudjEinAIKFVNpbXVsYXRlT3JkZXJzUmVxdWVzdBIrCgZvcmRlcnMYASADKAsyGy5kZXZ0b29sLnYxLk9yZGVyV2l0aE51bWJlchJLChRzaW11bGF0aW9uX3JlbGF0aW9ucxgCIAMoCzItLmRldnRvb2wudjEuT3JkZXJTaW11bGF0aW9uUmVsYXRpb25XaXRoTnVtYmVyEg8KB2Nhc2VfaWQYAyABKAkSPgoVc2ltdWxhdGlvbl90YXJnZXRfbm93GAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEgAiAEBEh4KFndpdGhfdW5pdF9wcmljZV9idWZmZXIYBSABKAhCGAoWX3NpbXVsYXRpb25fdGFyZ2V0X25vdyJbChZTaW11bGF0ZU9yZGVyc1Jlc3BvbnNlEkEKB291dHB1dHMYASADKAsyMC5kZXZ0b29sLnYxLlNpbXVsYXRlUEZFT3V0cHV0c1dpdGhSZWxhdGlvbk51bWJlciIcChpMaXN0RmxvYXRpbmdJbmRpY2VzUmVxdWVzdCJNChtMaXN0RmxvYXRpbmdJbmRpY2VzUmVzcG9uc2USLgoFaXRlbXMYASADKAsyHy5iZmZwb3J0YWwudjEuRmxvYXRpbmdJbmRleEl0ZW0ywAIKEVNpbXVsYXRpb25TZXJ2aWNlEowBCg5TaW11bGF0ZU9yZGVycxIjLmJmZnBvcnRhbC52MS5TaW11bGF0ZU9yZGVyc1JlcXVlc3QaJC5iZmZwb3J0YWwudjEuU2ltdWxhdGVPcmRlcnNSZXNwb25zZSIvmpAbKwoTZWNsZWFyLWJhc2ljLW1hc3RlcgoUZWNsZWFyLWJhc2ljLWRlZmF1bHQSmwEKE0xpc3RGbG9hdGluZ0luZGljZXMSKC5iZmZwb3J0YWwudjEuTGlzdEZsb2F0aW5nSW5kaWNlc1JlcXVlc3QaKS5iZmZwb3J0YWwudjEuTGlzdEZsb2F0aW5nSW5kaWNlc1Jlc3BvbnNlIi+akBsrChNlY2xlYXItYmFzaWMtbWFzdGVyChRlY2xlYXItYmFzaWMtZGVmYXVsdELHAQoQY29tLmJmZnBvcnRhbC52MUIWU2ltdWxhdGlvblNlcnZpY2VQcm90b1ABWkpnaXRodWIuY29tL2VuZWNoYWluL2Vwb3NpdGlvbi1hcHAvYmFja2VuZC9nZW4vcHJvdG8vYmZmcG9ydGFsL3YxO2JmZnBvcnRhbKICA0JYWKoCDEJmZnBvcnRhbC5WMcoCDEJmZnBvcnRhbFxWMeICGEJmZnBvcnRhbFxWMVxHUEJNZXRhZGF0YeoCDUJmZnBvcnRhbDo6VjFiBnByb3RvMw", [file_acl_v1_acl, file_bffportal_v1_floating_index_model, file_devtool_v1_service, file_google_protobuf_timestamp]);

/**
 * @generated from message bffportal.v1.SimulateOrdersRequest
 */
export type SimulateOrdersRequest = Message<"bffportal.v1.SimulateOrdersRequest"> & {
  /**
   * @generated from field: repeated devtool.v1.OrderWithNumber orders = 1;
   */
  orders: OrderWithNumber[];

  /**
   * @generated from field: repeated devtool.v1.OrderSimulationRelationWithNumber simulation_relations = 2;
   */
  simulationRelations: OrderSimulationRelationWithNumber[];

  /**
   * @generated from field: string case_id = 3;
   */
  caseId: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp simulation_target_now = 4;
   */
  simulationTargetNow?: Timestamp;

  /**
   * Default: false
   *
   * @generated from field: bool with_unit_price_buffer = 5;
   */
  withUnitPriceBuffer: boolean;
};

/**
 * Describes the message bffportal.v1.SimulateOrdersRequest.
 * Use `create(SimulateOrdersRequestSchema)` to create a new message.
 */
export const SimulateOrdersRequestSchema: GenMessage<SimulateOrdersRequest> = /*@__PURE__*/
  messageDesc(file_bffportal_v1_simulation_service, 0);

/**
 * @generated from message bffportal.v1.SimulateOrdersResponse
 */
export type SimulateOrdersResponse = Message<"bffportal.v1.SimulateOrdersResponse"> & {
  /**
   * @generated from field: repeated devtool.v1.SimulatePFEOutputsWithRelationNumber outputs = 1;
   */
  outputs: SimulatePFEOutputsWithRelationNumber[];
};

/**
 * Describes the message bffportal.v1.SimulateOrdersResponse.
 * Use `create(SimulateOrdersResponseSchema)` to create a new message.
 */
export const SimulateOrdersResponseSchema: GenMessage<SimulateOrdersResponse> = /*@__PURE__*/
  messageDesc(file_bffportal_v1_simulation_service, 1);

/**
 * @generated from message bffportal.v1.ListFloatingIndicesRequest
 */
export type ListFloatingIndicesRequest = Message<"bffportal.v1.ListFloatingIndicesRequest"> & {
};

/**
 * Describes the message bffportal.v1.ListFloatingIndicesRequest.
 * Use `create(ListFloatingIndicesRequestSchema)` to create a new message.
 */
export const ListFloatingIndicesRequestSchema: GenMessage<ListFloatingIndicesRequest> = /*@__PURE__*/
  messageDesc(file_bffportal_v1_simulation_service, 2);

/**
 * @generated from message bffportal.v1.ListFloatingIndicesResponse
 */
export type ListFloatingIndicesResponse = Message<"bffportal.v1.ListFloatingIndicesResponse"> & {
  /**
   * @generated from field: repeated bffportal.v1.FloatingIndexItem items = 1;
   */
  items: FloatingIndexItem[];
};

/**
 * Describes the message bffportal.v1.ListFloatingIndicesResponse.
 * Use `create(ListFloatingIndicesResponseSchema)` to create a new message.
 */
export const ListFloatingIndicesResponseSchema: GenMessage<ListFloatingIndicesResponse> = /*@__PURE__*/
  messageDesc(file_bffportal_v1_simulation_service, 3);

/**
 * @generated from service bffportal.v1.SimulationService
 */
export const SimulationService: GenService<{
  /**
   * @generated from rpc bffportal.v1.SimulationService.SimulateOrders
   */
  simulateOrders: {
    methodKind: "unary";
    input: typeof SimulateOrdersRequestSchema;
    output: typeof SimulateOrdersResponseSchema;
  },
  /**
   * @generated from rpc bffportal.v1.SimulationService.ListFloatingIndices
   */
  listFloatingIndices: {
    methodKind: "unary";
    input: typeof ListFloatingIndicesRequestSchema;
    output: typeof ListFloatingIndicesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffportal_v1_simulation_service, 0);

